import styled from 'styled-components';

export const LiveGuidelineDetailTabContainer = styled('div')`
    min-width: 1024px;
`;
